import { getGlobalActionHeaders } from '@decisions/server/DecisionsFramework/ServiceLayer/Actions/Common/CommonActionService';
import { ActionHeader, EntityActionType } from '@decisions/server/DecisionsFramework/ServiceLayer/Actions';
import create, { GetState, SetState } from 'zustand';
import { filterActions } from 'utils/ActionUtils';

type IGlobalActionsStoreState = typeof initialState;
type IGlobalActionsStore = IGlobalActionsStoreState & { actions: ReturnType<typeof createGlobalActionsActions> };

const initialState = {
  globalActions: [] as ActionHeader[],
  globalActionsOpen: false,
};

/**
 * Store for root / global actions.
 */
export const useGlobalActionsStore = create<IGlobalActionsStore>((set, get) => ({
  ...initialState,
  actions: createGlobalActionsActions(set, get),
}));

/**
 * @param get zustand store getter
 * @param set zustand store setter
 * @returns actions object.
 */
export function createGlobalActionsActions(set: SetState<IGlobalActionsStore>, get: GetState<IGlobalActionsStore>) {
  // TODO whatever subscription for getting assignment updates via notifications/pubsub, whatever

  return {
    /**
     * Load actions for user.
     */
    async loadGlobalActions(actionType: EntityActionType = EntityActionType.Silverlight, preLoaded?: ActionHeader[]) {
      // const displayType = getCookieDisplayType();
      const globalActions = preLoaded || (await getGlobalActionHeaders({ actionTypes: [actionType] }));

      set({ globalActions: filterActions(globalActions) });

      // set(
      //   produce<IGlobalActionsStore>(state => {
      //     // TODO store by ID for easy loading by ID later
      //   })
      // );
    },
    /**
     * toggle portal actions menu
     */
    toggleGlobalActionsMenu: (open?: boolean) => {
      const globalActionsOpen = open === undefined ? !get().globalActionsOpen : open;
      set({ globalActionsOpen });
    },
  };
}

//#region selectors

export function getGlobalActions(state: IGlobalActionsStoreState) {
  return state.globalActions;
}

export function getGlobalActionsOpen(state: IGlobalActionsStoreState) {
  return state.globalActionsOpen;
}

//#endregion
